<section class="question-collection__section">
  @for (collection of contentsCollections; track collection; let i = $index) {
    <div class="question-collection__container">
      <div class="question-collection__text">
        @if (isFirstSection && i === 0 && collection.seperatorTitle) {
          <h1
            class="question-collection__text__seperator-title"
            [innerHTML]="collection.seperatorTitle"
          ></h1>
        }
        @if (!isFirstSection || (i !== 0 && collection.seperatorTitle)) {
          <h2
            class="question-collection__text__seperator-title"
            [innerHTML]="collection.seperatorTitle"
          ></h2>
        }
        @if (!collection.seperatorTitle) {
          <div class="question-collection__text__seperator-placeholder"></div>
        }
        @if (collection.title) {
          <h2
            class="question-collection__text__title"
            [innerHTML]="collection.title"
          ></h2>
        }
        @if (!collection.title) {
          <div class="question-collection__text__title-placeholder"></div>
        }
      </div>
      @for (question of collection.contents; track question) {
        <app-question-collection-card
          [title]="question.title"
          [description]="question.description"
        ></app-question-collection-card>
      }
    </div>
  }
</section>
